import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/IndustrySectorController/CreateIndustrySectorController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateIndustrySector({ industrySector, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ IndustrialSector: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (industrySector) {
            setFormData({
                IndustrialSector: industrySector.IndustrialSector
            });
        } else {
            setFormData({ IndustrialSector: '' }); // Clear form data when switching to add mode
        }
    }, [industrySector]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        if (industrySector) {
            formData.ID = industrySector.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        const response = await handleSubmit(event, formData, setFormData, setErrors);
        onSuccess();
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>

                <div className="modal fade industrySectorModal show d-block" id="industrySectorModal" tabIndex="-1" aria-labelledby="industrySectorLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{industrySector ? "Edit Category" : "Add Category"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Category:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="IndustrialSector" value={formData.IndustrialSector} onChange={handleFieldChange} />
                                        {errors.IndustrialSector && <div style={{ color: 'red' }}>{errors.IndustrialSector}</div>}
                                    </div>

                                </div>


                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {industrySector ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    );
}

export default CreateIndustrySector;